import { useClerkEventTracking } from '../hooks/useClerkEventTracking';

export const ClerkEventTracker = ({ children }) => {
  useClerkEventTracking();
  return children;
};